import {
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiltersPanel, SearchBar } from '../../../components';
import FiltrePrimary from './filtersPrimary';
import FiltresSecondary from './filtersSecondary';
import { ISearchFiltres as ISearchFilters } from '../types';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';

interface IFilterProps {
  types: string[];
  onFiter: (filters: ISearchFilters) => void;
}

const initialStateFilter = {
  title: undefined,
  types: undefined,
  expeditionDateStart: undefined,
  expeditionDateEnd: undefined,
  publicationDateStart: undefined,
  publicationDateEnd: undefined,
  description: undefined,
  secretaryEntityName: undefined, 
  validity: undefined,
  subject : undefined
};

const Filter = ({ types, onFiter: onFilter }: IFilterProps) => {
  const { t } = useTranslation();
  const [isFilterPrimary, setIsFilterPrimary] = useState<boolean>(false);
  const [state, setState] = useState<ISearchFilters>(initialStateFilter);
  const handleChangeCheckFilter = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    reset();
    setIsFilterPrimary(event.target.checked);
  };

  const onSearch = (value: string) => {
    const clone = { ...state } as ISearchFilters;
    clone.title = value;
    onFilter(clone);
    setState(clone);
  };

  const onSelectType = (types: string[] | undefined) => {
    const clone = { ...state } as ISearchFilters;
    clone.types = types;
    onFilter(clone);
    setState(clone);
  };

  const onChangeDate = (
    isExpeditionDate: boolean,
    startDate?: Date,
    endDate?: Date
  ) => {
    const clone = { ...state } as ISearchFilters;
    if (isExpeditionDate) {
      clone.expeditionDateStart = startDate;
      clone.expeditionDateEnd = endDate;
    } else {
      clone.publicationDateStart = startDate;
      clone.publicationDateEnd = endDate;
    }
    onFilter(clone);
    setState(clone);
  };

  const onChangeDescription = (value: string) => {
    const clone = { ...state } as ISearchFilters;
    clone.description = value;
    onFilter(clone);
    setState(clone);
  };

  const onChangeSecretaryEntity = (value: string) => {
    const clone = { ...state } as ISearchFilters;
    clone.secretaryEntityName = value;
    onFilter(clone);
    setState(clone);
  };

  const onChangeValidity = (value: string) => {
    const clone = { ...state } as ISearchFilters;
    clone.validity = value;
    onFilter(clone);
    setState(clone);
  };

  const reset = () => {
    onFilter(initialStateFilter);
    setState(initialStateFilter);
  };

  return (
    <FiltersPanel>
      <List>
        <ListItem button onClick={reset}>
          <ListItemIcon>
            <RotateLeftIcon />
          </ListItemIcon>
          <ListItemText primary={t('pages.politics.reset')} />
        </ListItem>
      </List>
      <SearchBar placeholder={t('components.filtersPanel.search')} onSearch={onSearch} />
      <br />
      <FormControlLabel
        control={
          <Checkbox
            checked={isFilterPrimary}
            onChange={handleChangeCheckFilter}
            color='primary'
          />
        }
        label={t('pages.adsOffice.labelFilter')}
      />
      {!isFilterPrimary ? (
        <FiltrePrimary types={types} onSelectType={onSelectType} values={state?.types || []} />
      ) : (
        <FiltresSecondary
          types={types}
          onChangeDescription={onChangeDescription}
          onChangeTypes={onSelectType}
          onChangeDate={onChangeDate}
          onChangeSecretaryEntity={onChangeSecretaryEntity}
          onChangeValidity={onChangeValidity}
          state={state}
        />
      )}
    </FiltersPanel>
  );
};
export default Filter;
